/** DIRECT_OUTREACH_TOKEN_FIELD is the token provided in the hash fragment of the URL used to authenticate
retail users who come to the platform via direct outreach (via mediant). */
export const DIRECT_OUTREACH_TOKEN_FIELD = 'token'
